<div class="hbox-nospace" style="width: 100%;">
<ng-select class="micro-select-combo micro-select-pagination"
           [ngClass]="{'bold': selected, 'micro-select-combo-nominwidth': noMinWidth}"
           style="width: 100%;"
           [(ngModel)]="selected"
           [items]="options"
           [trackByFn]="trackById"
           [searchable]="true"
           [typeahead]="searchTerms"
           [virtualScroll]="false"
           [loading]="loading"
           [disabled]="disabled || requires"
             [clearable]="true"
           [placeholder]="required ? (requires ? requires : (placeholder ? 'Select ' + placeholder : 'Select')) : (allLabel ? allLabel : placeholder)"
           appendTo="body"
             (change)="change($event)"
             (clear)="change(null)">
  <ng-template ng-label-tmp let-item="item">
    {{getOptionLabel(item)}}
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    {{getOptionLabel(item)}} {{item?.error ? '(BROKEN)' : ''}}
  </ng-template>

  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <span *ngIf="!loading">No matching options</span>
  </ng-template>

  <ng-template ng-footer-tmp>
    <small *ngIf="totalElements > pageSize" class="lightly-padded">
      +{{totalElements - pageSize}} more, start typing to filter results.
    </small>
  </ng-template>
</ng-select>
  <div class="margin-auto" *ngIf="canJump">
    <a class="margin-auto"
       routerLink="/{{routerBase}}/{{id}}"
       matTooltip="Jump to {{getOptionLabel(selected)}}">
      <mat-icon class="icon-small">call_made</mat-icon>
    </a>
  </div>
</div>
